import { keccak256 } from './keccak';
/**
 * derive Address from public key
 * @param pubKey the public key
 */
export function publicKeyToAddress(pubKey) {
    return keccak256(pubKey.slice(1)).slice(12);
}
/**
 * to check if a value presents an address
 * @param v the value to be checked
 */
export function isAddress(v) {
    return typeof v === 'string' && /^0x[0-9a-f]{40}$/i.test(v);
}
/**
 * encode the address to checksum address that is compatible with eip-55
 * @param address input address
 */
export function toChecksumAddress(address) {
    if (!isAddress(address)) {
        throw new Error('invalid address');
    }
    address = address.slice(2).toLowerCase();
    const hash = keccak256(address);
    let checksumAddress = '0x';
    for (let i = 0; i < address.length; i++) {
        // tslint:disable-next-line:no-bitwise
        let byte = hash[i >> 1];
        if (i % 2 === 0) {
            // tslint:disable-next-line:no-bitwise
            byte >>= 4;
        }
        if (byte % 16 >= 8) {
            checksumAddress += address[i].toUpperCase();
        }
        else {
            checksumAddress += address[i];
        }
    }
    return checksumAddress;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRkcmVzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jcnkvYWRkcmVzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sVUFBVSxDQUFBO0FBQ3BDOzs7R0FHRztBQUNILE1BQU0sVUFBVSxrQkFBa0IsQ0FBQyxNQUFjO0lBQzdDLE9BQU8sU0FBUyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDLENBQUE7QUFDL0MsQ0FBQztBQUVEOzs7R0FHRztBQUNILE1BQU0sVUFBVSxTQUFTLENBQUMsQ0FBTTtJQUM1QixPQUFPLE9BQU8sQ0FBQyxLQUFLLFFBQVEsSUFBSSxtQkFBbUIsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUE7QUFDL0QsQ0FBQztBQUVEOzs7R0FHRztBQUNILE1BQU0sVUFBVSxpQkFBaUIsQ0FBQyxPQUFlO0lBQzdDLElBQUksQ0FBQyxTQUFTLENBQUMsT0FBTyxDQUFDLEVBQUU7UUFDckIsTUFBTSxJQUFJLEtBQUssQ0FBQyxpQkFBaUIsQ0FBQyxDQUFBO0tBQ3JDO0lBQ0QsT0FBTyxHQUFHLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsV0FBVyxFQUFFLENBQUE7SUFDeEMsTUFBTSxJQUFJLEdBQUcsU0FBUyxDQUFDLE9BQU8sQ0FBQyxDQUFBO0lBRS9CLElBQUksZUFBZSxHQUFHLElBQUksQ0FBQTtJQUMxQixLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsT0FBTyxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUUsRUFBRTtRQUNyQyxzQ0FBc0M7UUFDdEMsSUFBSSxJQUFJLEdBQUcsSUFBSSxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQTtRQUN2QixJQUFJLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQyxFQUFFO1lBQ2Isc0NBQXNDO1lBQ3RDLElBQUksS0FBSyxDQUFDLENBQUE7U0FDYjtRQUVELElBQUksSUFBSSxHQUFHLEVBQUUsSUFBSSxDQUFDLEVBQUU7WUFDaEIsZUFBZSxJQUFJLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQyxXQUFXLEVBQUUsQ0FBQTtTQUM5QzthQUFNO1lBQ0gsZUFBZSxJQUFJLE9BQU8sQ0FBQyxDQUFDLENBQUMsQ0FBQTtTQUNoQztLQUNKO0lBQ0QsT0FBTyxlQUFlLENBQUE7QUFDMUIsQ0FBQyJ9